// extracted by mini-css-extract-plugin
export default {"WarningModal":"WarningModal_WarningModal__adRFp","WarningModal__text":"WarningModal_WarningModal__text__2k-77","WarningModal__button":"WarningModal_WarningModal__button__3Rymo"};